const SaveStripePaymentTransactionAPIConstants = {
	mywishes: {
		transactions: "/transactions",
	},
};

export { SaveStripePaymentTransactionAPIConstants };
